<template>
    <div class="hs-container">
        <div class="handle-box">
            <div class="handle-left">
                <div class="search-left">

                    <el-select v-model="query.news_type" placeholder="订单类型" class="handle-input mr10">
                        <el-option v-for="item in planNewsTypeList" :key="item.id" :label="item.title" :value="item.id">
                        </el-option>
                    </el-select>
                    <el-select v-model="query.company_id" placeholder="执行公司" filterable clearable
                        class="handle-input mr10">
                        <el-option v-for="(item, index) in dictionary.getPicker('company')" :key="index"
                            :label="item.title" :value="item.id+''"></el-option>
                    </el-select>
                    <el-date-picker class="daterange mr10" v-model="query.date_range" type="daterange"
                        value-format="yyyy-MM-dd" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
                    <el-select v-model="query.hotel_id" placeholder="举办酒店" class="handle-input mr10" filterable
                        clearable>
                        <el-option v-for="(item, index) in dictionary.getPicker('hotel')" :key="index"
                            :label="item.title" :value="item.id+''"></el-option>
                    </el-select>

                    <user-picker class="handle-input mr10" v-model="query.sales_id" placeholder="请选择销售"
                        :roles="[5,6,8]"></user-picker>
                    <user-picker class="handle-input mr10" v-model="query.planer_id" placeholder="请选择策划师"
                        :roles="[32, 35]"></user-picker>
                    <el-input v-model="query.keywords" placeholder="手机号/客户姓名/微信号" clearable
                        class="handle-input mr10"></el-input>
                    <el-button type="primary" class="btn-search ml8" @click="changeHandler">搜索</el-button>
                    <el-popover placement="bottom" width="600" trigger="click">
                        <div class="help-container">
                            <div>
                                <el-tag type="danger">四大金刚状态</el-tag>
                                <dl class="help-box">
                                    <dt>发起申请:</dt>
                                    <dd>策划师未提交需求</dd>
                                </dl>
                                <dl class="help-box">
                                    <dt>待分配:</dt>
                                    <dd>已提交需求，待总控部派发供应商</dd>
                                </dl>
                                <dl class="help-box">
                                    <dt>已派单:</dt>
                                    <dd>总控专员已派发摄影师/化妆师/司仪/摄影摄像，待主管领导审核</dd>
                                </dl>
                                <dl class="help-box">
                                    <dt>已确定:</dt>
                                    <dd>总控部已与供应商"确定"需求</dd>
                                </dl>
                                <dl class="help-box">
                                    <dt>已作废:</dt>
                                    <dd>当前申请已被总控部作废</dd>
                                </dl>
                            </div>
                            <div>
                                <el-tag type="danger">需求单状态</el-tag>
                                <dl class="help-box">
                                    <dt>发起申请:</dt>
                                    <dd>策划师未提交需求</dd>
                                </dl>
                                <dl class="help-box">
                                    <dt>待审核:</dt>
                                    <dd>策划师已提交申请，待相关人员审核</dd>
                                </dl>
                                <dl class="help-box">
                                    <dt>审核中:</dt>
                                    <dd>策划师已提交申请，部分相关人员已审核，尚未审核完成。</dd>
                                </dl>
                                <dl class="help-box">
                                    <dt>审核通过:</dt>
                                    <dd>策划师已提交申请，审核已通过</dd>
                                </dl>
                                <dl class="help-box">
                                    <dt>审核驳回:</dt>
                                    <dd>策划师已提交申请，审核已驳回</dd>
                                </dl>
                            </div>
                            <div>
                                <el-tag type="danger">设计单状态</el-tag>
                                <dl class="help-box">
                                    <dt>发起申请:</dt>
                                    <dd>策划师未提交需求</dd>
                                </dl>
                                <dl class="help-box">
                                    <dt>待审核:</dt>
                                    <dd>策划师已提交申请，待相关人员审核</dd>
                                </dl>
                                <dl class="help-box">
                                    <dt>审核中:</dt>
                                    <dd>策划师已提交申请，部分相关人员已审核，尚未审核完成。</dd>
                                </dl>
                                <dl class="help-box">
                                    <dt>审核通过:</dt>
                                    <dd>策划师已提交申请，审核已通过</dd>
                                </dl>
                                <dl class="help-box">
                                    <dt>审核驳回:</dt>
                                    <dd>策划师已提交申请，审核已驳回</dd>
                                </dl>
                            </div>
                            <div>
                                <el-tag type="danger">工程单状态</el-tag>
                                <dl class="help-box">
                                    <dt>发起申请:</dt>
                                    <dd>策划师未提交需求</dd>
                                </dl>
                                <dl class="help-box">
                                    <dt>待审核:</dt>
                                    <dd>策划师已提交申请，待相关人员审核</dd>
                                </dl>
                                <dl class="help-box">
                                    <dt>审核中:</dt>
                                    <dd>策划师已提交申请，部分相关人员已审核，尚未审核完成。</dd>
                                </dl>
                                <dl class="help-box">
                                    <dt>审核通过:</dt>
                                    <dd>策划师已提交申请，审核已通过</dd>
                                </dl>
                                <dl class="help-box">
                                    <dt>审核驳回:</dt>
                                    <dd>策划师已提交申请，审核已驳回</dd>
                                </dl>
                            </div>
                            <div>
                                <el-tag type="danger">采购单状态</el-tag>
                                <dl class="help-box">
                                    <dt>发起申请:</dt>
                                    <dd>策划师未提交需求</dd>
                                </dl>
                                <dl class="help-box">
                                    <dt>待审核:</dt>
                                    <dd>策划师已提交申请，待相关人员审核</dd>
                                </dl>
                                <dl class="help-box">
                                    <dt>审核中:</dt>
                                    <dd>策划师已提交申请，部分相关人员已审核，尚未审核完成。</dd>
                                </dl>
                                <dl class="help-box">
                                    <dt>审核通过:</dt>
                                    <dd>策划师已提交申请，审核已通过</dd>
                                </dl>
                                <dl class="help-box">
                                    <dt>审核驳回:</dt>
                                    <dd>策划师已提交申请，审核已驳回</dd>
                                </dl>
                            </div>
                        </div>
                        <el-button slot="reference" class="ml8" type="danger">注解</el-button>
                    </el-popover>
                </div>
            </div>
        </div>
        <!-- 搜索E -->

        <div class="table-box">
            <el-table :data="tableData" border :height="tableHeight" :max-height="tableHeight" v-loading="loading"
                @sort-change="sortChange">
                <el-table-column prop="planner[0].realname" label="策划师"></el-table-column>
                <el-table-column prop="service.title" label="执行公司"></el-table-column>
                <el-table-column prop="news_type" label="信息类型"></el-table-column>
                <el-table-column prop="bridegroom" label="客户姓名"></el-table-column>
                <el-table-column prop="hotel" label="酒店" show-overflow-tooltip></el-table-column>
                <el-table-column prop="hall" label="厅" show-overflow-tooltip></el-table-column>
                <el-table-column prop="event_date" label="举办日期" align="center" sortable="custom"></el-table-column>
                <el-table-column prop="compere" label="司仪" align="center">
                    <template slot-scope="scope">
                        <el-button v-if="Object.keys(scope.row.compere).length == 0" type="text"
                            @click="showDrawerPass(_self, 'planDetail', 'showDialog', [scope.row.id, 'wedding'])">发起申请</el-button>
                        <template v-else>
                            <!-- 0=待分配;1=已派单；2=已确定;3=重新派单中; 4=已作废 -->
                            <el-button v-if="scope.row.compere.status == 0" type="primary" size="mini"
                                @click="showDrawerPass(_self, 'planDetail', 'showDialog', [scope.row.id, 'wedding'])">待分配</el-button>
                            <el-button v-if="scope.row.compere.status == 1" type="success" size="mini"
                                @click="showDrawerPass(_self, 'planDetail', 'showDialog', [scope.row.id, 'wedding'])">已派单</el-button>
                            <el-button v-if="scope.row.compere.status == 2" type="warning" size="mini"
                                @click="showDrawerPass(_self, 'planDetail', 'showDialog', [scope.row.id, 'wedding'])">已确定</el-button>
                            <el-button v-if="scope.row.compere.status == 4" type="info" size="mini"
                                @click="showDrawerPass(_self, 'planDetail', 'showDialog', [scope.row.id, 'wedding'])">已作废</el-button>
                        </template>
                    </template>
                </el-table-column>
                <el-table-column prop="makeup" label="化妆" align="center">
                    <template slot-scope="scope">
                        <el-button v-if="Object.keys(scope.row.makeup).length == 0" type="text"
                            @click="showDrawerPass(_self, 'planDetail', 'showDialog', [scope.row.id, 'wedding'])">发起申请</el-button>
                        <template v-else>
                            <el-button v-if="scope.row.makeup.status == 0" type="primary" size="mini"
                                @click="showDrawerPass(_self, 'planDetail', 'showDialog', [scope.row.id, 'wedding'])">待分配</el-button>
                            <el-button v-if="scope.row.makeup.status == 1" type="success" size="mini"
                                @click="showDrawerPass(_self, 'planDetail', 'showDialog', [scope.row.id, 'wedding'])">已派单</el-button>
                            <el-button v-if="scope.row.makeup.status == 2" type="warning" size="mini"
                                @click="showDrawerPass(_self, 'planDetail', 'showDialog', [scope.row.id, 'wedding'])">已确定</el-button>
                            <el-button v-if="scope.row.makeup.status == 4" type="info" size="mini"
                                @click="showDrawerPass(_self, 'planDetail', 'showDialog', [scope.row.id, 'wedding'])">已作废</el-button>
                        </template>
                    </template>
                </el-table-column>
                <el-table-column prop="camera" label="摄像" align="center">
                    <template slot-scope="scope">
                        <el-button v-if="Object.keys(scope.row.camera).length == 0" type="text"
                            @click="showDrawerPass(_self, 'planDetail', 'showDialog', [scope.row.id, 'wedding'])">发起申请</el-button>
                        <template v-else>
                            <el-button v-if="scope.row.camera.status == 0" type="primary" size="mini"
                                @click="showDrawerPass(_self, 'planDetail', 'showDialog', [scope.row.id, 'wedding'])">待分配</el-button>
                            <el-button v-if="scope.row.camera.status == 1" type="success" size="mini"
                                @click="showDrawerPass(_self, 'planDetail', 'showDialog', [scope.row.id, 'wedding'])">已派单</el-button>
                            <el-button v-if="scope.row.camera.status == 2" type="warning" size="mini"
                                @click="showDrawerPass(_self, 'planDetail', 'showDialog', [scope.row.id, 'wedding'])">已确定</el-button>
                            <el-button v-if="scope.row.camera.status == 4" type="info" size="mini"
                                @click="showDrawerPass(_self, 'planDetail', 'showDialog', [scope.row.id, 'wedding'])">已作废</el-button>
                        </template>
                    </template>
                </el-table-column>
                <el-table-column prop="shoot" label="摄影" align="center">
                    <template slot-scope="scope">
                        <el-button v-if="Object.keys(scope.row.shoot).length == 0" type="text"
                            @click="showDrawerPass(_self, 'planDetail', 'showDialog', [scope.row.id, 'wedding'])">发起申请</el-button>
                        <template v-else>
                            <el-button v-if="scope.row.shoot.status == 0" type="primary" size="mini"
                                @click="showDrawerPass(_self, 'planDetail', 'showDialog', [scope.row.id, 'wedding'])">待分配</el-button>
                            <el-button v-if="scope.row.shoot.status == 1" type="success" size="mini"
                                @click="showDrawerPass(_self, 'planDetail', 'showDialog', [scope.row.id, 'wedding'])">已派单</el-button>
                            <el-button v-if="scope.row.shoot.status == 2" type="warning" size="mini"
                                @click="showDrawerPass(_self, 'planDetail', 'showDialog', [scope.row.id, 'wedding'])">已确定</el-button>
                            <el-button v-if="scope.row.shoot.status == 4" type="info" size="mini"
                                @click="showDrawerPass(_self, 'planDetail', 'showDialog', [scope.row.id, 'wedding'])">已作废</el-button>
                        </template>
                    </template>
                </el-table-column>
                <el-table-column prop="demand" label="需求单" align="center">
                    <template slot-scope="scope">
                        <el-button v-if="Object.keys(scope.row.demand).length == 0" type="text"
                            @click="showDrawerPass(_self, 'planDetail', 'showDialog', [scope.row.id, 'wedding'])">发起申请</el-button>
                        <el-button v-else type="primary" size="mini"
                            @click="showDrawerPass(_self, 'planDetail', 'showDialog', [scope.row.id])">{{getItemCheckTitle(scope.row.demand.item_check_status)}}</el-button>
                    </template>
                </el-table-column>
                <el-table-column prop="design" label="设计单" align="center">
                    <template slot-scope="scope">
                        <el-button v-if="Object.keys(scope.row.design).length == 0" type="text"
                            @click="showDrawerPass(_self, 'planDetail', 'showDialog', [scope.row.id, 'design'])">发起申请</el-button>
                        <el-button v-else type="primary" size="mini"
                            @click="showDrawerPass(_self, 'planDetail', 'showDialog', [scope.row.id])">{{getItemCheckTitle(scope.row.design.item_check_status)}}</el-button>
                    </template>
                </el-table-column>
                <el-table-column prop="purchase" label="采购单" align="center">
                    <template slot-scope="scope">
                        <el-button v-if="Object.keys(scope.row.purchase).length == 0" type="text"
                            @click="showDrawerPass(_self, 'planDetail', 'showDialog', [scope.row.id, 'wedding'])">发起申请</el-button>
                        <el-button v-else type="primary" size="mini"
                            @click="showDrawerPass(_self, 'planDetail', 'showDialog', [scope.row.id, 'wedding'])">{{getItemCheckTitle(scope.row.purchase.item_check_status)}}</el-button>
                    </template>
                </el-table-column>
                <el-table-column prop="project" label="工程单" align="center">
                    <template slot-scope="scope">
                        <el-button v-if="Object.keys(scope.row.project).length == 0" type="text"
                            @click="showDrawerPass(_self, 'planDetail', 'showDialog', [scope.row.id, 'project'])">发起申请</el-button>
                        <el-button v-else type="primary" size="mini"
                            @click="showDrawerPass(_self, 'planDetail', 'showDialog', [scope.row.id])">{{getItemCheckTitle(scope.row.project.item_check_status)}}</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- 底部操作栏 -->
        <div class="footer-box">
            <div class="download"></div>
            <div class="pagination">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="pagination.page" :page-sizes="[15, 20, 50, 100]" :page-size="pagination.limit"
                    layout="total, sizes, prev, pager, next, jumper" :total="pagination.total"></el-pagination>
            </div>
        </div>

        <plan-detail ref="planDetail" :parent="_self"></plan-detail>
    </div>
</template>

<script>
import {
    showDrawerPass,
    getItemCheckTitle
} from '@/utils/common.js';
import dictionary from '@/utils/dictionary';
import planDetail from './detail.vue';
import userPicker from '@/components/picker/userByRole.vue'

const query = {
    news_type: "1",
    company_id: "",
    hotel_id: "",
    sales_id: "",
    planer_id: "",
    date_range: [],
    keywords: "", //手机号/客户姓名/微信号
    status: "0"
};

export default {
    components: {
        planDetail,
        userPicker
    },
    data() {
        let tableHeight = window.innerHeight - 252;
        let windowheight = window.innerHeight;
        return {
            tableData: [],
            query: Object.assign({}, query), // 搜索条件
            tableHeight: tableHeight,
            windowheight: windowheight,
            pagination: {
                page: 1,
                limit: 15,
                totals: 0
            },
            loading: false,
            sort: {},
        };
    },
    computed: {
        planNewsTypeList() {
            let planList = [{
                id: "1",
                title: "婚庆信息"
            },
            {
                id: "7",
                title: "宝宝宴"
            },
            {
                id: "8",
                title: "会务"
            },
            {
                id: "11",
                title: "婚博会"
            },
            {
                id: "12",
                title: "婚礼秀"
            }
            ];

            return planList;
        }
    },
    beforeCreate() {
        this.showDrawerPass = showDrawerPass;
        this.getItemCheckTitle = getItemCheckTitle;
        this.dictionary = dictionary;
    },
    created() {
        let _this = this;
        _this.getTableData();
        if (this.$route.query.order_id) {
            let orderId = this.$route.query.order_id;
            let demandId = this.$route.query.demand_id; //
            let categoryId = this.$route.query.category_id; //
            let typeId = this.$route.query.m; //
            let ext = {
                order_id: orderId,
                demand_id: demandId,
                category_id: categoryId,
                m: typeId,
            }
            if (_this.$refs['planDetail']) {
                _this.$refs['planDetail'].showDialog(orderId, '', ext);
            } else {
                _this.$nextTick(function () {
                    _this.$refs['planDetail'].showDialog(orderId, '', ext);
                })
            }
        }
    },
    methods: {
        changeHandler(value) {
            this.query.status = value;
            this.pagination.page = 1;
            this.getTableData();
        },
        getTableData() {
            let _this = this;
            _this.loading = true;
            let url = '/api/plan.order/index';
            let query = this.query;
            query['pagination'] = _this.pagination;
            query['sort'] = _this.sort;
            this.$post(url, query).then((res) => {
                _this.tableData = res.data.list;
                _this.pagination = res.data.pagination;
                _this.loading = false;
            });
        },
        // 排序
        sortChange(e) {
            if (e.order) {
                let sort = {};
                sort.field = e.prop;
                sort.order = e.order == 'descending' ? 'desc' : 'asc';
                this.sort = sort;
            } else {
                this.sort = {};
            }
            this.getTableData();
        },
        // 分页
        handleSizeChange(val) {
            this.pagination.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.pagination.page = val;
            this.getTableData();
        },
        getStatus(status) {
            let title = '';
            switch (status) {
                case 0:
                    title = '待分配';
                    break;
                case 1:
                    title = '已派单';
                    break;
                case 2:
                    title = '分派中';
                    break;
                case 3:
                    title = '已完成';
                    break;
                case 4:
                    title = '已作废';
                    break;
                default:
                    title = '';
            }

            return title;
        },
    }
};
</script>

<style lang="less">
@import url('@/assets/css/common.less');
</style>
